import { useMutation } from "@apollo/client";
import { LOGS_STAND_REPORT } from "graphql/mutation/log-gql";
import { successNotification, errorNotification } from "components/request-result";
import { saveAs } from "file-saver";


const useMutationStandReport = () => {

    function getFileNameFromUrl(url) {
        const value = url.split('/');
        return value[ value.length - 1 ];
    }

    const [ _setStandReport, { loading } ] = useMutation(LOGS_STAND_REPORT,
        {
            update(cache, { data }) {

                const {
                    logsStandReportExel: {
                        label,
                        message,
                        file
                    }
                } = data;

                successNotification({
                    title: label,
                    description: message
                })


                saveAs(file, getFileNameFromUrl(file));
            },


            onError(error) {
                errorNotification(error);
            },

        }
    );


    return {
        _setStandReport,
        loadingMutationStandReport: loading,
    }
};


export default useMutationStandReport;

